import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link, Redirect } from 'react-router-dom'
import {
    FormattedMessage,
    FormattedNumber,
    injectIntl,
} from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import SideBar from '../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import Icon from "../common/icon/icon.component.jsx";
import NewInvoiceModal from "./newmodal.component.jsx";
import GlobalHelper from "../common/GlobalHelper.jsx";
import NoResult from "../common/listing/noresult.component.jsx";
import InvoicesTabs from "../common/layout/tabs/invoices.component.jsx";
import moment from "moment";
import { SingleDatePicker } from "react-dates";

class InvoiceAgeingReport extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            interval: 30,
            headers: [],
            rows: [],
            searchKeywords: '',
            modal: '',
            statuses: [],
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            loading: true,
            draftCount: 0,
            draftAmount: 0,
            partiallyPaidCount: 0,
            partiallyPaidAmount: 0,
            sentCount: 0,
            sentAmount: 0,
            fullyPaidCount: 0,
            fullyPaidAmount: 0,
            orderByField: 'totalBalance',
            drillDown: {},
            data: [],
            dataWithoutMergingEmployees: [],
            asc: false,
            cutOffDate: moment(),
        }
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handleStatusSelectChange = this.handleStatusSelectChange.bind(this)
        this.handleUserSelectChange = this.handleUserSelectChange.bind(this)
        this.openInvoiceCreationModal = this.openInvoiceCreationModal.bind(this)
        this.closeInvoiceCreationModal = this.closeInvoiceCreationModal.bind(this)
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this)
        this.handleClearFilters = this.handleClearFilters.bind(this)
        this.exportCsv = this.exportCsv.bind(this)
        this.refreshReport = this.refreshReport.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('invoice')
        this.refreshReport()
    }

    refreshReport() {
        AppContext.getApiClient().post('/reports/invoices-ageing-report', {
            cutOffDate: this.state.cutOffDate.toDate().toISOString(),
            interval: this.state.interval,
        }).then(res => {
            this.state.data = res.data
            this.setState({
                headers: res.data.length > 0 ? this.headers() : [],
                dataWithoutMergingEmployees: this.formatData(res.data, true),
                data: this.formatData(res.data, false),
                totalItemsCount: res.metadata.totalItemsCount,
                footer: this.footer(res.metadata),
            }, () => {
                this.setState({
                    loading: false,
                    rows: this.sortRows(this.state.orderByField, this.state.asc, false),
                })
            })
        })
    }

    formatData(data, separateEntryForEmployees = false) {
        const companies = {}
        let rows = []
        for (let i in data) {
            let item = data[i]
            if (parseFloat(item.totalBalance) == 0) {
                continue
            }
            if (item.organizationId && !separateEntryForEmployees) {
                let row = companies[item.organizationId] || {
                    bucket0: 0,
                    bucket1: 0,
                    bucket2: 0,
                    bucket3: 0,
                    bucket4: 0,
                    contactId: item.organizationId,
                    contactName: item.organizationName,
                    invoicesCount: 0,
                    organizationId: '',
                    organizationName: '',
                    totalBalance: 0,
                    rows: [],
                    type: 'organizations'
                }
                row.bucket0 += parseFloat(item.bucket0)
                row.bucket1 += parseFloat(item.bucket1)
                row.bucket2 += parseFloat(item.bucket2)
                row.bucket3 += parseFloat(item.bucket3)
                row.bucket4 += parseFloat(item.bucket4)
                row.invoicesCount += parseFloat(item.invoicesCount)
                row.totalBalance += parseFloat(item.totalBalance)
                item.subRow = true
                row.rows.push(item)
                companies[item.organizationId] = row
            } else {
                item.rows = []
                item.type = 'persons'
                item.subRow = false
                rows.push(item)
            }
        }
        for (let i in companies) {
            rows.push(companies[i])
        }
        return rows
    }

    exportCsv(e) {
        e.preventDefault()
        const rows = [
            [
                this.props.intl.formatMessage({ id: 'invoice.report.ageing.headers.id_label', defaultMessage: "Contact" }),
                this.props.intl.formatMessage({ id: 'invoice.report.ageing.headers.organization_name_label', defaultMessage: "Organization" }),
                this.props.intl.formatMessage({ id: 'invoice.report.ageing.headers.total_balance_label', defaultMessage: "Owing balance" }),
                this.props.intl.formatMessage({ id: 'invoice.report.ageing.headers.last_days_balance_label' }, { count: this.state.interval }),
                this.props.intl.formatMessage({ id: 'invoice.report.ageing.headers.over_days_balance_label' }, { count: this.state.interval }),
                this.props.intl.formatMessage({ id: 'invoice.report.ageing.headers.over_days_balance_label' }, { count: this.state.interval * 2 }),
                this.props.intl.formatMessage({ id: 'invoice.report.ageing.headers.over_days_balance_label' }, { count: this.state.interval * 3 }),
                this.props.intl.formatMessage({ id: 'invoice.report.ageing.headers.over_days_balance_label' }, { count: this.state.interval * 4 }),
                this.props.intl.formatMessage({ id: 'invoice.report.ageing.headers.is_archived_label', defaultMessage: "Archived" }),
            ]
        ].concat(
            this.sortRows(this.state.orderByField, this.state.asc, true, true).map(row => {
                return [
                    row.contactName.replaceAll(",", "-"),
                    row.organizationName.replaceAll(",", "-"),
                    row.totalBalance,
                    row.bucket0,
                    row.bucket1,
                    row.bucket2,
                    row.bucket3,
                    row.bucket4,
                    row.isArchived,
                ]
            })
        )
        const csvContent = ""
            + rows.map(e => e.join(",")).join("\n");

        const fileName = moment().format('YYYY-MM-DD') + '_aging_report.csv'

        const blob = new Blob([csvContent]);
        if (window.navigator.msSaveOrOpenBlob)
            window.navigator.msSaveBlob(blob, fileName);
        else {
            let a = window.document.createElement("a")
            a.href = window.URL.createObjectURL(blob, { type: "text/csv" })
            a.download = fileName
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        }
    }

    sortRows(field, asc, json, separateEntryForEmployees = false) {
        let unsortedData = !separateEntryForEmployees ? this.state.data : this.state.dataWithoutMergingEmployees
        const data = unsortedData.sort((a, b) => {
            let first = a
            let second = b
            if (!asc) {
                first = b
                second = a
            }
            return parseFloat(first[field]) - parseFloat(second[field])
        })
        if (json) {
            return data
        }
        return data.map(q => this.row(q))
    }

    updateSorting(field) {
        return function (e) {
            e.preventDefault()
            let asc = this.state.asc
            if (field === this.state.orderByField) {
                asc = !asc
                this.state.asc = asc
            }
            this.setState({
                rows: this.sortRows(field, asc),
                orderByField: field,
                asc: asc,
            }, () => {
                this.setState({
                    headers: this.headers(),
                })
            })
        }.bind(this)
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.refreshSearch()
        })
    }

    handleSearchChange(event) {
        const target = event.target;
        this.setState({
            searchKeywords: target.value,
            activePage: 1,
        }, () => {
            this.refreshSearch()
        })
    }

    headers() {
        const sortIcon = <Icon value={this.state.asc ? 'sort-up' : 'sort-down'} className={'ml-1'} />
        return {
            classNames: ['', 'text-right', 'text-right', 'text-right', 'text-right', 'text-right', 'text-right'],
            data: [
                <FormattedMessage
                    id="invoice.report.ageing.headers.id_label"
                    defaultMessage="Contact"
                />,
                <a href={'#'} onClick={this.updateSorting('bucket0')}>
                    <FormattedMessage
                        id="invoice.report.ageing.headers.last_days_balance_label"
                        defaultMessage="Last {count} days"
                        values={{
                            count: this.state.interval
                        }}
                    />
                    {this.state.orderByField === 'bucket0' ? sortIcon : ''}
                </a>,
                <a href={'#'} onClick={this.updateSorting('bucket1')}>
                    <FormattedMessage
                        id="invoice.report.ageing.headers.over_days_balance_label"
                        defaultMessage="Over {count} days"
                        values={{
                            count: this.state.interval
                        }}
                    />
                    {this.state.orderByField === 'bucket1' ? sortIcon : ''}
                </a>,
                <a href={'#'} onClick={this.updateSorting('bucket2')}>
                    <FormattedMessage
                        id="invoice.report.ageing.headers.over_days_balance_label"
                        defaultMessage="Over {count} days"
                        values={{
                            count: this.state.interval * 2
                        }}
                    />
                    {this.state.orderByField === 'bucket2' ? sortIcon : ''}
                </a>,
                <a href={'#'} onClick={this.updateSorting('bucket3')}>
                    <FormattedMessage
                        id="invoice.report.ageing.headers.over_days_balance_label"
                        defaultMessage="Over {count} days"
                        values={{
                            count: this.state.interval * 3
                        }}
                    />
                    {this.state.orderByField === 'bucket3' ? sortIcon : ''}
                </a>,
                <a href={'#'} onClick={this.updateSorting('bucket4')}>
                    <FormattedMessage
                        id="invoice.report.ageing.headers.over_days_balance_label"
                        defaultMessage="Over {count} days"
                        values={{
                            count: this.state.interval * 4
                        }}
                    />
                    {this.state.orderByField === 'bucket4' ? sortIcon : ''}
                </a>,
                <a href={'#'} onClick={this.updateSorting('totalBalance')}>
                    <FormattedMessage
                        id="invoice.report.ageing.headers.total_balance_label"
                        defaultMessage="Owing balance"
                    />
                    {this.state.orderByField === 'totalBalance' ? sortIcon : ''}
                </a>,
            ],
        }
    }

    footer(meta) {
        return {
            classNames: ['pl-4', 'text-right pr-4', 'text-right pr-4', 'text-right pr-4', 'text-right pr-4', 'text-right pr-4', 'text-right pr-4'],
            data: [
                <strong>{meta.customersCount}</strong>,
                <strong><FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={meta.totalBucket0}
                /></strong>,
                <strong><FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={meta.totalBucket1}
                /></strong>,
                <strong><FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={meta.totalBucket2}
                /></strong>,
                <strong><FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={meta.totalBucket3}
                /></strong>,
                <strong><FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={meta.totalBucket4}
                /></strong>,
                <strong><FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={meta.grandTotal}
                /></strong>,
            ],
        }
    }

    contactIcon(type) {
        if (type === 'organizations') {
            return <Icon value={"building"} className={'mr-1'} />
        }
        return <Icon value={"user"} className={'mr-1'} />
    }

    triggerDrillDown(contactId) {
        const drillDown = this.state.drillDown
        let status = drillDown[contactId] || false
        drillDown[contactId] = !status
        this.setState({
            drillDown: drillDown,
        })
    }

    row(row) {
        return {
            rowId: row.contactId,
            extra: {
                rows: row.rows || [],
            },
            className: row.subRow ? 'bg-light' : '',
            classNames: ['', 'text-right', 'text-right', 'text-right', 'text-right', 'text-right', 'text-right'],
            data: [
                <span>
                    <Link className={row.isArchived ? "text-danger" : ""} to={'/contacts/' + row.contactId + '/details'}>
                        {row.subRow ? <Icon value={'angle-right'} /> : null}
                        {this.contactIcon(row.type)}
                        {row.contactName}
                    </Link>
                    <small>
                        {row.type === 'organizations' ? <a href={'#'} className={'btn btn-sm ml-1 btn-link'} onClick={e => {
                            e.preventDefault()
                            this.triggerDrillDown(row.contactId)
                        }}>
                            [+<FormattedMessage
                                id="common.report.btn.drill_down"
                                defaultMessage="drill down"
                            />]
                        </a> : null}
                    </small>
                </span>,
                <FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={row.bucket0}
                />,
                <FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={row.bucket1}
                />,
                <FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={row.bucket2}
                />,
                <FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={row.bucket3}
                />,
                <FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={row.bucket4}
                />,
                <FormattedNumber
                    style="currency"
                    currency={AppContext.getAccount().attributes.currency}
                    value={row.totalBalance}
                />,
            ],
        }
    }


    handleStatusSelectChange(statuses) {
        this.setState({
            statuses: statuses,
            activePage: 1,
        }, () => {
            this.refreshSearch()
        })
    }

    handleUserSelectChange(userId) {
        this.setState({
            userId: userId,
            activePage: 1,
        }, () => {
            this.refreshSearch()
        })
    }

    openInvoiceCreationModal(event) {
        event.preventDefault()
        this.setState({
            modal: <NewInvoiceModal
                recurring={true}
                onClose={this.closeInvoiceCreationModal}
            />
        })
    }

    closeInvoiceCreationModal(invoiceId) {
        this.setState({
            modal: invoiceId ? <Redirect to={'/invoices/' + invoiceId + '/edit'} /> : ''
        })
    }

    handlePageSizeChange(size) {
        this.setState({
            pageSize: size
        }, () => {
            this.refreshSearch()
        })
    }

    handleClearFilters() {
        this.setState({
            activePage: 1,
            searchLabelIds: [],
            searchKeywords: '',
            statuses: [],
            userId: '',
        }, () => {
            this.refreshSearch()
        })
    }

    render() {
        if (AppContext.getAccount().attributes.onBoardingStatus === "pending") {
            return <Redirect to={{ pathname: '/' }} />
        }

        let rows = []
        for (let i in this.state.rows) {
            const row = this.state.rows[i]
            rows.push(row)
            if (this.state.drillDown[row.rowId]) {
                rows = rows.concat(row.extra.rows.map(r => this.row(r)))
            }
        }

        let list = <StandardList
            smallLine={true}
            className="row pt-3 d-none d-sm-none d-md-block"
            headers={this.state.headers}
            rows={rows}
            footer={this.state.footer}
            footerClassName={'bg-secondary text-white'}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        } else if (this.state.rows.length === 0 && GlobalHelper.hasAtLeastOneListingFilter('listingRecurringInvoices')) {
            list = <NoResult onClearFilters={this.handleClearFilters} />
        }

        return (
            <div>
                <InvoicesTabs />
                <div className={'row d-flex justify-content-between'}>
                    <div className={'ml-3'}>
                        <p className={'mb-0 text-secondary'}>
                            <small className={'strong'}>
                                <FormattedMessage
                                    id="invoices.ageing.report.cut_off_date"
                                    defaultMessage="Cut off date"
                                />
                            </small>
                        </p>
                        <SingleDatePicker
                            block
                            small
                            displayFormat="LL"
                            focused={this.state.focused}
                            isOutsideRange={() => false}
                            onDateChange={(date) => {
                                this.setState({
                                    cutOffDate: date.endOf('day')
                                }, this.refreshReport)
                            }}
                            onFocusChange={({ focused }) => this.setState({ focused })}
                            date={this.state.cutOffDate}
                            numberOfMonths={1}
                        />
                    </div>
                    <div className={'mr-3'}>
                        <button className={'btn btn-secondary'} onClick={this.exportCsv}>
                            <Icon value={'file-csv'} className={'mr-1'} />
                            <FormattedMessage
                                id="common.report.btn.export_csv"
                                defaultMessage="Export to csv"
                            />
                        </button>
                    </div>
                </div>
                {list}
            </div>
        );
    }
}

export default injectIntl(InvoiceAgeingReport)



// WEBPACK FOOTER //
// ./src/invoice/ageingreport.component.jsx